/** Build-time UI feature flags.
 *
 *  CRA only exposes REACT_APP_* variables to the bundle, so craco.config.js
 *  copies the plain names (e.g. AGENTS_UI_PREVIEW) onto their REACT_APP_
 *  counterparts before the build reads them. Either spelling works:
 *
 *    AGENTS_UI_PREVIEW=true yarn start
 *    REACT_APP_AGENTS_UI_PREVIEW=true yarn build
 *
 *  Anything other than the string "true" counts as disabled. */
const on = (v) => String(v || "").trim().toLowerCase() === "true";

export const AGENTS_UI_PREVIEW = on(process.env.REACT_APP_AGENTS_UI_PREVIEW);
